import $ from "jquery";
import Isotope from "isotope-layout";
import SimpleLightbox from "simplelightbox";

require('isotope-packery');

if($('.grid--gallery').length) {
    var elem = document.querySelector('.grid--gallery');
    var iso = new Isotope( elem, {
      // options
      itemSelector: '.grid-item',
      layoutMode: 'packery'
    });
  }
  
  if($('.grid--galleries').length) {
    var elem = document.querySelector('.grid--galleries');
    var iso = new Isotope( elem, {
      // options
      itemSelector: '.grid-item',
      layoutMode: 'packery'
    });
  }
  
  let gallery = new SimpleLightbox('.gallery a', {
    'animationSpeed': 150
  });